import { DataAttributeDefinitions, provideDataClass } from 'scrivito'

import { DataClassName, PisaDataClassEndpoint } from '@/Data/const'
import { createPisaRestApiConfig } from '@/Data/pisaClient'

const schemaDataClassName = DataClassName.SCHEMA
const schemaURL = PisaDataClassEndpoint.SCHEMA

export function pisaSchemaDataClass(attributes: DataAttributeDefinitions) {
  return provideDataClass(schemaDataClassName, {
    title: schemaDataClassName,
    restApi: createPisaRestApiConfig(schemaURL),
    attributes,
  })
}
